"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/other-pages/contact-us/contactUs.tsx */

import { FC } from "react";

export type MapSectionGeneratedProps = {
    /** Default: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.7301009561315!2d-76.13077892422932!3d36.82498697224007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89bae976cfe9f8af%3A0xa61eac05156fbdb9!2sBeachStreet%20USA!5e0!3m2!1sen!2sin!4v1669777904208!5m2!1sen!2sin" */
    divIframe0IframeSrc?: string;
};

const MapSectionGenerated: FC<MapSectionGeneratedProps> = ({
    divIframe0IframeSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.7301009561315!2d-76.13077892422932!3d36.82498697224007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89bae976cfe9f8af%3A0xa61eac05156fbdb9!2sBeachStreet%20USA!5e0!3m2!1sen!2sin!4v1669777904208!5m2!1sen!2sin",
}) => {
    return (
        <div className="contact-map d-flex">
            <iframe src={divIframe0IframeSrc} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        </div>
    );
};

export default MapSectionGenerated;
